import gql from 'graphql-tag'
import client from '@stores/apollo'
import { ILocationBookableDesk } from '@api/types'
import { LocationFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  viewer: {
    company: {
      bookableLocations: ILocationBookableDesk[]
    }
  }
}

const mutateHandler = handleFetchResult<IPayload, ILocationBookableDesk[]>({
  handler: (data) => data.viewer.company.bookableLocations,
  name: 'Capacity Location',
})

function fetch(): Promise<ILocationBookableDesk[]> {
  return client.gql.query({ query: locationBookableDeskGroupsQuery }).then(mutateHandler)
}

const locationBookableDeskGroupsQuery = gql`
  query locationBookableDesks {
    viewer {
      company {
        bookableLocations {
          bookableSpaceTypes
          locations {
            ...LocationFragment
          }
        }
      }
    }
  }
  ${LocationFragment}
`

interface MutationInput {
  bookableSpaceTypes?: string[]
  locationIds: string[]
}

// will want to reload after adding
function add(input: MutationInput) {
  return client.gql.mutate({ mutation: addMutation, variables: { input } })
}

const addMutation = gql`
  mutation addBookableToLocations($input: AddBookableToLocationsInput!) {
    addBookableToLocations(input: $input) {
      locations {
        city
      }
    }
  }
`

// will want to reload after updating
function update(input: MutationInput & { id: string }) {
  return client.gql.mutate({ mutation: updateMutation, variables: { input } })
}

const updateMutation = gql`
  mutation updateLocationsBookable($input: UpdateLocationsBookableInput!) {
    updateLocationsBookable(input: $input) {
      locations {
        city
      }
    }
  }
`

// will want to reload after removing
function remove(input: { locationIds: string[] }) {
  return client.gql.mutate({ mutation: removeMutation, variables: { input } })
}

const removeMutation = gql`
  mutation deleteLocationsBookable($input: DeleteLocationsBookableInput!) {
    deleteLocationsBookable(input: $input) {
      locations {
        city
      }
    }
  }
`

export default { fetch, add, update, remove }
